export default {
	// addListSaveRows_: function (state) {
	// 	return state.partsInfo.filter(el => el.tableState === 'I' || el.tableState === 'U');
	// }

	getStartDt_: ({ searchParams }) => searchParams.stdDt
};
